import * as types from '../actions/actionTypes';

const initialState = {
  receiptUrl: "",
  receiptSignature: "", // pngBase64
  receiptReferral: null, // {referralPercent: 10, referralAmount: 500 // not used}, this is for dashboard messaging,
  // to create purchase order receipt // dashboard job object
  // home depot receipt only (fabricatorData.receiptSettings?.homeDepotReceipt), filled in on the /sign page:
  receiptWorkOrderNumber: "",
  receiptHDLeadNumber: "",
  receiptBathroomLocation: "",
  receiptEstimateStart: "",
  receiptEstimatedText: "",
};

export default function (state = initialState, action) {

  switch (action.type) {

    case types.SET_RECEIPT_URL:
    case types.SET_RECEIPT_SIGNATURE:
    case types.SET_RECEIPT_REFERRAL:
    case types.SET_RECEIPT_HOME_DEPOT_FIELDS:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
